import React from 'react';
// Components
import MultipleAttachmentItem from './components/MultipleAttachmentItem/MultipleAttachmentItem';
// Icons
import { ReactComponent as Asset } from '@assets/icons/asset.svg';
// Styles
import styles from './MultipleAttachments.module.scss';
// Types
import { MultipleAttachmentsProps } from './MultipleAttachmentsProps';

const MultipleAttachments = (props: MultipleAttachmentsProps) => {
  const { files, setFiles } = props;

  const addFileHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    
    if (!e.target.files) return;

    const newFile = e.target.files[0];

    const idList = Object.keys(files);
    const lastIndex = idList[0] === undefined ? 0 : idList[idList.length - 1];
    const newIndex = +lastIndex + 1;

    setFiles({ ...files, [newIndex]: newFile });
  };

  const removeFileHandler = (id: number) => {
    const newFiles = files;

    delete newFiles[id];

    setFiles({ ...newFiles });
  };

  return (
    <div>
      <label className={styles.input}>
        <Asset />
        <span>Add file</span>
        <input
          type="file"
          name="file"
          id="file"
          onChange={addFileHandler}
          value={''}
        />
      </label>
      <div className={styles.list}>
        {Object.keys(files).map((id) => (
          <MultipleAttachmentItem key={id} id={id} name={files[+id].name} deleteHandler={removeFileHandler} />
        ))}
      </div>
    </div>
  );
};

export default MultipleAttachments;
